export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

export const fetchConfig = (type = 'json') => ({
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Accept: `application/${type}`,
  },
});

/**
 * Behaves the same as setInterval except uses requestAnimationFrame() where possible for better performance
 * @param {function} fn The callback function
 * @param {int} delay The delay in milliseconds
 */
export const requestInterval = (fn, delay) => {
  let start = new Date().getTime(),
    // eslint-disable-next-line prefer-const
    handle = {};

  function loop() {
    const current = new Date().getTime(),
      delta = current - start;

    if (delta >= delay) {
      fn.call();
      start = new Date().getTime();
    }

    handle.value = requestAnimationFrame(loop);
  }

  handle.value = requestAnimationFrame(loop);
  return handle;
};

/**
 * Behaves the same as clearInterval except uses cancelRequestAnimationFrame() where possible for better performance
 * @param {int|object} handle The callback function
 */
export const clearRequestInterval = (handle) => {
  if (typeof handle === 'number') {
    handle = { value: handle };
  }
  window.cancelAnimationFrame(handle.value);
};

/**
 * Behaves the same as setTimeout except uses requestAnimationFrame() where possible for better performance
 * @param {function} fn The callback function
 * @param {int} delay The delay in milliseconds
 */

export const requestTimeout = (fn, delay) => {
  const start = new Date().getTime(),
    handle = {};

  function loop() {
    const current = new Date().getTime(),
      delta = current - start;

    // eslint-disable-next-line no-unused-expressions
    delta >= delay ? fn.call() : (handle.value = requestAnimationFrame(loop));
  }

  handle.value = requestAnimationFrame(loop);
  return handle;
};

/**
 * Behaves the same as clearTimeout except uses cancelRequestAnimationFrame() for better performance
 * @param {int|object} handle The callback function
 */
export const clearRequestTimeout = (handle) => {
  if (typeof handle === 'number') {
    handle = { value: handle };
  }
  window.cancelAnimationFrame(handle.value);
};

export const showToast = (message, iconUrl, appearanceTimeArg) => {
  if (!message) {
    return;
  }

  let appearanceTime = Math.max(5000, message.length * 70);
  if (appearanceTimeArg) {
    appearanceTime = appearanceTimeArg;
  }

  let iconHtml = '';
  if (iconUrl) {
    iconHtml = `<img class='toast-icon' src='${iconUrl}' alt='' height="17" />`;
  }

  const notificationOverlayElement = document.createElement('div');
  notificationOverlayElement.className = 'toast-container';

  notificationOverlayElement.innerHTML = `<div class='toast-content'>${iconHtml} ${message}</div>`;

  document.body.appendChild(notificationOverlayElement);

  requestTimeout(() => {
    notificationOverlayElement.classList.add('toast-container--visible');

    requestTimeout(() => {
      notificationOverlayElement.classList.add('toast-container--animate-out');

      setTimeout(() => {
        notificationOverlayElement.remove();
      }, 500);
    }, appearanceTime);
  }, 1);
};

export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email.toLowerCase());
};
